import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface SignatureControlsProps {
  consent: string;
  disabled: boolean;
  onSubmit: () => void;
  onClear: () => void;
}

export const SignatureControls = ({
  consent,
  disabled,
  onSubmit,
  onClear
}: SignatureControlsProps) => {
  return (
    <Stack direction="column" spacing={3}>
      <Typography marginTop={1}>{consent}</Typography>
      <Stack direction="row" spacing={1}>
        <Button
          type="button"
          variant="outlined"
          onClick={onSubmit}
          disabled={disabled}
        >
          Commit Signature
        </Button>
        <Button
          type="button"
          variant="text"
          onClick={onClear}
          disabled={disabled}
        >
          Clear
        </Button>
      </Stack>
    </Stack>
  );
};
